import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Calendar from '@/views/Calendar.vue';
import CalendarMonth from '@/components/Calendar/Month.vue';
import CalendarDay from '@/components/Calendar/Day.vue';
import Configurations from '@/views/Configurations.vue';
import ServiceRequirements from '@/views/ServiceRequirements.vue';
import Unit from '@/views/Unit.vue';
import Units from '@/views/Units.vue';
import Containers from '@/views/Containers.vue';
import ContainerSizes from '@/views/ContainerSizes.vue';
import Users from '@/views/Users.vue';
import Defects from '@/views/Defects.vue';
import Garages from '@/views/Garages.vue';
import Audit from '@/views/Audit.vue';
import Campaigns from '@/views/Campaigns.vue';
import Reports from '@/views/Reports.vue';
import NhvasReports from '@/views/NhvasReports.vue';
import Announcements from '@/views/Announcements.vue';
import UserAnnouncements from '@/views/UserAnnouncements.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar,
            redirect: { name: 'calendar-month' },
            children: [
                {
                    name: 'calendar-month',
                    path: 'month/:date?',
                    component: CalendarMonth,
                    meta: { requireAuth: true }
                },
                {
                    name: 'calendar-day',
                    path: 'day/:date?',
                    component: CalendarDay,
                    meta: { requireAuth: true }
                }
            ]
        },
        {
            path: '/configurations',
            name: 'configurations',
            component: Configurations,
            meta: { requireAuth: true }
        },
        {
            path: '/service-requirements',
            name: 'service-requirements',
            component: ServiceRequirements,
            meta: { requireAuth: true }
        },
        {
            path: '/units/:unitId',
            name: 'unit',
            component: Unit,
            meta: { requireAuth: true }
        },
        {
            path: '/units',
            name: 'units',
            component: Units,
            meta: { requireAuth: true }
        },
        {
            path: '/containers',
            name: 'containers',
            component: Containers,
            meta: { requireAuth: true }
        },
        {
            path: '/container-sizes',
            name: 'container-sizes',
            component: ContainerSizes,
            meta: { requireAuth: true }
        },
        {
            path: '/users',
            name: 'users',
            component: Users,
            meta: { requireAuth: true }
        },
        {
            path: '/defects',
            name: 'defects',
            component: Defects,
            meta: { requireAuth: true }
        },
        {
            path: '/garages',
            name: 'garages',
            component: Garages,
            meta: { requireAuth: true }
        },
        {
            path: '/reports',
            name: 'reports',
            component: Reports,
            meta: { requireAuth: true }
        },
        {
            path: '/nhvas-reports',
            name: 'nhvas-reports',
            component: NhvasReports,
            meta: { requireAuth: true }
        },
        {
            path: '/auditing',
            name: 'auditing',
            component: Audit,
            meta: { requireAuth: true }
        },
        {
            path: '/campaigns',
            name: 'campaigns',
            component: Campaigns,
            meta: { requireAuth: true }
        },
        {
            path: '/announcements',
            name: 'announcements',
            component: Announcements,
            meta: { requireAuth: true }
        },
        {
            path: '/user-announcements',
            name: 'user-announcements',
            component: UserAnnouncements,
            meta: { requireAuth: true }
        }
    ]
});
